<!-- =========================================================================================
  File Name: InviteCamUserSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isStudentSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <span class="flex items-center" style="word-break: normal;">
          <h6>ADD {{ $t('student.title') }} FOR:</h6> 
        <vs-chip color="primary">
          <vs-avatar v-if="dataUserImage" :src="img_cdn+dataUserImage"/>        
          <vs-avatar v-else />
             <p> {{ dataUserFirstName+' '+dataUserLastName }}</p>
        </vs-chip>
      </span>

        <feather-icon icon="XIcon" @click.stop="isStudentSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <vs-row>
    <vs-col vs-w="12">
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="flex p-6 pb-0">
          <vs-checkbox v-model="BoxNew">Add New</vs-checkbox>
        </div>
        <br>
      <div class="p-6" v-if="BoxEx">
        <div>
        <label class="vs-select--label w-full">Select Existing {{ $t('student.titlesmall') }}</label>
        <v-select   label="name"   :closeOnSelect="true" v-model="student" :options="students"   />
        </div>
      </div>
       <div class="p-6" v-else>
        <template >
           <!-- <vs-button @click="openLoadingInDiv" >Div with Loading</vs-button> -->

            <div class="contained-example-container">
            <div id="div-with-loading" class="vs-con-loading__container">
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center vs-con-loading__container" id="div-with-loading">
            <img v-if="ImgName" :src="dataImg" loading="lazy" class="responsive">
          </div>
          </div>
            </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click.native="$refs.updateImgInput.click()">{{this.ImgName == null ? "Upload" : "Update" }} {{$t('student.add.image')}}</vs-button>
            <vs-button v-if="ImgName!==null" type="flat" color="#999" @click.native="ImgName = null , dataImg = null">{{$t('student.add.btn_remove_image')}}</vs-button>
          </div>
        </template>
        <!-- NAME -->
        <vs-input v-if="lng!='dogs'" label="First Name *" v-model="dataFirstName" class="mt-5 w-full" :name="$t('student.add.first_name')" v-validate="'required'"   maxlength="50"/>
        <vs-input v-else :label="$t('student.add.first_name')" v-model="dataFirstName" class="mt-5 w-full" :name="$t('student.add.first_name')" v-validate="'required'"   maxlength="50"/>
        <span class="text-danger text-sm" v-show="errors.has($t('student.add.first_name'))">{{ errors.first($t('student.add.first_name')) }}</span>

        <vs-input v-if="lng!='dogs'" :label="$t('student.add.middle_name')"  v-model="dataMiddleName" class="mt-5 w-full" :name="$t('student.add.middle_name')"   maxlength="50"/>

        <vs-input v-if="lng!='dogs'" :label="$t('student.add.last_name')" v-model="dataLastName" class="mt-5 w-full" :name="$t('student.add.last_name')" v-validate="'required'"  maxlength="50"/>
        <span class="text-danger text-sm" v-show="errors.has($t('student.add.last_name'))">{{ errors.first($t('student.add.last_name')) }}</span>
         <!-- NICk Name -->
        <vs-input v-if="lng!='dogs'" :label="$t('student.add.nick_name')"  v-model="dataNick" class="mt-5 w-full" :name="$t('student.add.nick_name')"   maxlength="50"/><br>
        <!-- <span class="text-danger text-sm" v-show="errors.has('Nick Name')">{{ errors.first('Nick Name') }}</span><br> -->
        <!-- CATEGORY -->
        <label class="vs-select--label w-full">{{$t('student.add.dob')}}</label>
      <vs-row>
  <vs-col  vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
    <datepicker class="w-full"  v-model="dataBirthday" format="MM/dd/yyyy"  :minimumView="'day'" :maximumView="'year'" :initialView="'month'"></datepicker><span v-if="dataBirthday" class="mb-8 ml-1"  @click="dataBirthday = null">x</span>

  </vs-col>
  <!-- <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
   </vs-col> -->
</vs-row><br>

        <label class="vs-select--label w-full">{{$t('student.add.location')}}</label>
         <v-select  label="name" :closeOnSelect="true" v-model="dataLocation" v-on:input="selectLocation" :options="UserLocations"/><br>

        <!-- <ul class="centerx mt-2  flex flex-wrap">
         <li class="ml-1" v-for="location in UserLocations" :key="location.id">
         <vs-radio v-model="dataLocation" @change="getLocation(location,'new')" :vs-value="location.id">{{location.name}}</vs-radio>
        </li>
        </ul> -->
        <label class="vs-select--label w-full">{{$t('student.add.program')}}</label>
        <v-select  label="name"   :closeOnSelect="true" v-model="dataProgram"  :options="programs"  /><br>

        <!-- ORDER STATUS -->

        <label class="vs-select--label w-full">{{$t('student.add.cameras')}}</label>
        <v-select  label="name"  multiple :closeOnSelect="true" v-model="dataCamera"  :options="cameras"/><br>

        <!-- STATUS -->
        <vs-row vs-w="12" class="ml-6">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="2" vs-xs="1">
            <label>Status</label>
          </vs-col>  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="9">
        </vs-col>  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="1">
          <vs-switch v-model="dataStatus"></vs-switch>
        </vs-col>
        </vs-row>

      </div>
    </component>
     </vs-col>
    </vs-row>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">{{ $t('user.add.btn_submit') }}</vs-button>
      <vs-button type="border" color="danger" @click.native="isStudentSidebarActiveLocal = false">{{ $t('user.add.btn_cancel') }}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

import {
  GET_USER_LOCATION_STUDENTS,
  ADD_USER_STUDENT,
  GET_CAMERA_BY_LOCATION, 
  GET_PROGRAM_BY_LOCATION,
  CREATE_USER_ACTIVITY,
  CREATE_STUDENT,
  MANAGER_LOCATION,
  GET_ALL_LOCATIONS
} from '@/graphql'
import S3 from 'aws-s3'
const config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url,
  dirName: process.env.VUE_APP_AWS_DIREC+'/StudentImage',
}
const S3Client = new S3(config)
export default {
  props: {
    isStudentSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
     Datepicker,
     moment
  },
  data () {
    return {
      img_cdn:process.env.VUE_APP_AWS_s3Url+"/",
      BoxEx:true,
      BoxNew:false,
      dataUserId:'',
      dataUserFirstName:'',
      dataUserLastName:'',
      dataUserImage:'',  
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      students:[],
      student:null,
      locations:[],
      
      UserLocations:[],
      ImgName:null,
      camusers:[],
      cameras:[],
      programs:[],
      dataId: null,
      dataFirstName: '',
      dataMiddleName: '',
      dataLastName: '',
      dataProgram: [],
      dataCamUser: [],
      dataCamera:[],
      dataLocation:'',
      dataImg: null,
      dataNick:'',
      dataStatus:true,
      dataBirthday:'',
      lng:'',
    }
  },
  watch: {
    isStudentSidebarActive (val) {
      if(val){
        this.BoxEx=true
      }
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id, fname, lname, image, locations} = JSON.parse(JSON.stringify(this.data))
        this.programs=[]
        this.UserLocations=locations
        this.dataUserId = id
        this.dataUserFirstName = fname
        this.dataUserLastName = lname
        this.dataUserImage = image
        if(locations.length > 0){
          this.UserLocations = locations
        }
        else{
          this.LocationforStudent()
        }
         const locations_id = []
        for (let index = 0; index < locations.length; index++) {
                  locations_id.push(locations[index].id)
                }

        if (locations_id.length > 0) {
          this.getUserLocationsStudent(locations_id, id)
        }
      }
    },
    BoxNew(val){
        this.BoxEx=!val
        if(val){
          this.resetField()
        }
    }

  },
  computed: {
    isStudentSidebarActiveLocal: {
      get () {
        return this.isStudentSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeStudentSidebar')
          // this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      if(this.BoxEx){
          return !this.errors.any() && this.student
      }
      else{
       if (this.lng == 'dogs') {
        this.dataLastName = 'pet'
      }
      return !this.errors.any() && this.dataProgram != '' && this.dataFirstName && this.dataLastName && this.dataLocation

      }
  
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
  selectLocation(event){
      if(event){
         if(!event.billing){
            this.$vs.notify({
            title: 'Error',
            text: 'This record is disabled because of its locations’ billing problems.',
            color: 'danger',
            position: 'top-right'
          })
           this.dataLocation='';
         }
         else{
            this.getLocation(event,'new');
         }
      }
      else{
        this.dataCamera = []
        this.dataProgram = []
      }
    },
     openLoadingInDiv () {
      this.$vs.loading({
        type:'sound',
        container: '#div-with-loading',
        scale: 0.6
      })
    },
     updateCurrImg (input) {
          const file = input.target.files[0]
          const name = Math.random().toString().slice(2)
          this.openLoadingInDiv()
          S3Client.uploadFile(file, name)
            .then(response => {
              this.ImgName = response.key
              this.dataImg = this.img_cdn+response.key
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            })
            .catch(err => console.error(err))
      },
  getLocation (location, msg) {
    if(location.billing){
      this.$apollo
        .mutate({
          mutation: GET_CAMERA_BY_LOCATION,
          variables: {
            location_id:location.id
          }
        })
        .then(response => {
          if (response) {
            this.cameras = response.data.location_cameras
            if (msg == 'new') {
              this.dataCamera = []
            }
          }
        }).catch(error => {
          console.log(error)
        })
      this.$apollo
        .mutate({
          mutation: GET_PROGRAM_BY_LOCATION,
          variables: {
            location_id:location.id
          }
        })
        .then(response => {
          if (response) {
            this.programs = response.data.location_programs
            if (msg == 'new') {
              this.dataProgram = []
            }
          }
        }).catch(error => {
          console.log(error)
        })
      }
      else{
        this.$vs.notify({
        title: 'Error',
        text: 'This record is disabled because of its locations’ billing problems.',
        color: 'danger',
        position: 'top-right'
      })
      this.dataLocation=''
      }
    },
    StatusSuccess () {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: `${this.$t('student.alert_title')  } added successfully!`,
        color: 'success',
        position: 'top-right'
      })
    },
    StatusFail () {
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: 'Failed to add!',
        color: 'danger',
        position: 'top-right'
      })
    },
    resetField(){
      this.dataFirstName = ''
      this.dataMiddleName = ''
      this.dataLastName = ''
      this.dataImg = null
      this.ImgName = null
      this.dataNick = ''
      this.dataProgram = []
      this.dataCamera = []
      this.dataCamUser = []
      this.dataLocation = ''
      this.dataBirthday = ''
      this.dataStatus = true
    },
    initValues () {
      this.dataUserFirstName = ''
      this.dataUserLastName = ''
      this.dataUserImage = ''
      this.student = null
      this.students = []
      this.dataUserId = null
      this.dataFirstName = ''
      this.dataMiddleName = ''
      this.dataLastName = ''
      this.dataImg = null
      this.ImgName = null
      this.dataNick = ''
      this.dataProgram = []
      this.dataCamera = []
      this.dataCamUser = []
      this.dataLocation = ''
      this.dataBirthday = ''
      this.dataSibling = ''
      this.dataStatus = true
      this.cameras = [],
      this.programs = [],
      this.BoxNew=false,
      this.BoxEx=true
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
        if(this.BoxEx){
          this.$apollo
            .mutate({
              mutation: ADD_USER_STUDENT,
              variables: {
                student:this.student.id,
                user: this.dataUserId
              }
            })
            .then(response => {
              if (response) {
                this.StatusSuccess()
                this.$emit('closeStudentSidebar')
                this.initValues()
              }
            }).catch(error => {
              this.StatusFail()
              console.log(error)
            })
        }
        if(this.BoxNew){
            this.dataCamUser = [this.dataUserId]
            const getcamerasids = []
            for (let j = 0; j < this.dataCamera.length; j++) {
              const getcameraid = this.dataCamera[j].id
              getcamerasids.push(getcameraid)
            }
           if (this.dataBirthday) {
              this.dataBirthday = moment(this.dataBirthday).format('YYYY-MM-DD')
            }
           this.$apollo
              .mutate({
                mutation: CREATE_STUDENT,
                variables: {
                  fname:this.dataFirstName,
                  middle_name:this.dataMiddleName,
                  lname: this.dataLastName,
                  nick_name: this.dataNick,
                  dob:this.dataBirthday,
                  image:this.ImgName,
                  status: this.dataStatus,
                  location_id: this.dataLocation.id,
                  program_id: this.dataProgram.id,
                  cameras: getcamerasids,
                  users: this.dataCamUser
                }
              })
              .then(response => {
                if (response) {
                  if (response.data.createStudent.status === 'Success') {
                    this.StatusSuccess()
                    this.$emit('closeStudentSidebar')
                     this.initValues()
                    this.userActivity(response.data.createStudent.id)
                  } else {
                    this.LocationLimitFail()
                  }
                }

              }).catch(error => {
                this.StatusFail()
                console.log(error)
              })


        }
        }
      }
      )
    },
    LocationLimitFail () {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: 'Cannot Exceed Location Limit. Failed to add!',
        color: 'danger',
        position: 'top-right'
      })
    },
      userActivity (id) {
      this.$apollo
        .mutate({
          mutation: CREATE_USER_ACTIVITY,
          variables: {
            object_id: id,
            object_type:'App\\Models\\Student',
            activity:'added'
          }
        })
    },
    getUserLocationsStudent (locations, user) {
      this.$apollo
        .mutate({
          mutation: GET_USER_LOCATION_STUDENTS,
          variables: {
            locations,
            user_id:user
          }
        })
        .then(response => {
          const students = []
          for (let i = 0; i < response.data.user_locations_student.length; i++) {
            if(response.data.user_locations_student[i].status){
            if (response.data.user_locations_student[i].middle_name) {
              response.data.user_locations_student[i].name = `${response.data.user_locations_student[i].fname} ${response.data.user_locations_student[i].middle_name}  ${response.data.user_locations_student[i].lname}`
            } else {
              response.data.user_locations_student[i].name = `${response.data.user_locations_student[i].fname} ${response.data.user_locations_student[i].lname}`
            }
            students.push(response.data.user_locations_student[i])
          } 
          }
          this.students = students

          //  this.students=response.data.user_locations_student
        }).catch(error => {

          console.log(error)

        })
    },
      LocationforStudent() {
      let userId= localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name
      this.conditionMethod(userRole,userId)
    },
     conditionMethod (role, id) {
      if (role == 'manager') {
        this.$apollo
        .mutate({
          mutation: MANAGER_LOCATION,
          variables: {
            id: id
          }
        })
        .then(response => {
              this.UserLocations = response.data.user.managerlocations
        })
      } else {
        this.getAllLocation()

      }
    },
    getAllLocation () {
      this.$apollo
        .mutate({
          mutation: GET_ALL_LOCATIONS
        })
        .then(response => {
             this.UserLocations=response.data.getAllLocations
        })
    },
  },
  created () {
    this.lng = process.env.VUE_APP_I18N_LOCALE
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
